import { makeStyles } from '../../../../../styles';
export default makeStyles((theme) => ({
    container: {
        width: '100%',
        padding: theme.spacing(1),
    },
    label: {
        fontSize: 13,
    },
    iconContainer: {
        minWidth: `${theme.spacing(2)} !important`,
    },
    icon: {
        fontSize: theme.spacing(2),
        marginRight: theme.spacing(1),
    },
}));
//# sourceMappingURL=ContextMenuOption.styles.js.map